import React from "react"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Flex, Typography } from "antd"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import Tippy from "@tippyjs/react"

import { WalletData } from "@src/app/balanceStore"
import css from "./index.module.css"

const tooltipText = ""

type Props = {
  balances: WalletData
}

export const MassPayoutCardsBalances = observer(({ balances }: Props) => {
  const options = computed(() =>
    balances.map((b) => ({ symbol: b.symbol, val: b.balances.available })),
  ).get()

  return (
    <Flex className={css.balancesWrap} justify="space-between">
      <Flex align="center" gap={6}>
        <Typography.Text className={css.balancesTitle}>
          Available balances:
        </Typography.Text>

        <Flex align="center" gap={24}>
          {options.map((b) => (
            <Flex className={css.balancesText} gap={6} key={b.symbol}>
              <Typography.Text className={css.balancesSymbol}>
                {b.symbol}:
              </Typography.Text>
              <Typography.Text>{b.val}</Typography.Text>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Tippy content={tooltipText}>
        <ExclamationCircleOutlined className={css.tooltip} />
      </Tippy>
    </Flex>
  )
})
